export default __webpack_public_path__ + "static/media/08-bose.05aa0d23.jpg";